import { useState } from "react";
import { api } from "../api";

/** Gut sichtbarer Hinweis, solange der HandVero-Support mit Freigabe in einem Kundenkonto arbeitet. */
export function SupportBanner({ support }: { support: { expiresAt: string } | null }) {
  const [busy, setBusy] = useState(false);
  if (!support) return null;
  const until = new Date(support.expiresAt).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  async function leave() {
    setBusy(true);
    const res = await api.post<{ backToAdmin: boolean }>("/api/support/leave").catch(() => ({ backToAdmin: false }));
    window.location.href = res.backToAdmin ? "/desktop/admin/firmen" : "/anmelden";
  }
  return (
    <div className="support-banner" role="status">
      <span className="support-dot" aria-hidden="true" />
      <span>
        <b>Support-Ansicht.</b> Mit Freigabe der Firma, bis {until}.
      </span>
      <button onClick={() => void leave()} disabled={busy}>
        Beenden
      </button>
    </div>
  );
}
